// extracted by mini-css-extract-plugin
export default {"recommendedFitContainer":"Vla-z","linkStyleCopy":"Wla-z"};